import myUtils from '../myUtils';
import apiAuth from './apiAuth';
import apiConfig from './apiConfig';

const apiUrl = apiConfig.configApiUrl
const options = (method, body) => apiConfig.configOptions(method, body)
const callApi = (_url, _options) => apiConfig.configCallApi(_url, _options)

//=================== Account API =============================//
const getAccounts = async ({ page = 0, pageSize = 100000, keyWord, role, propertyId, companyId}) => {//Account // page start at 0
    let paging = `,"limit":${pageSize > 0 ? pageSize : 100},"offset":${page*pageSize},"order":"createdAt ASC"`; 

    let filterKeyWord = '';
    if(keyWord && keyWord != ''){
        filterKeyWord = `,"or":[{"code":{"like":"${keyWord}"}},{"username":{"like":"${keyWord}"}},{"email":{"like":"${keyWord}"}},{"firstName":{"like":"${keyWord}"}},{"lastName":{"like":"${keyWord}"}},{"phone":{"like":"${keyWord}"}}]`;
    }
    let filterRole = '';
    if(role && role != ''){
        filterRole = `, "role": "${role}"`;
    }
    let filterPropertyId = '';
    if(propertyId && propertyId != ''){
        filterPropertyId = `, "propertyId": "${propertyId}"`;
    }
    let filterCompanyId = '';
    if(companyId && companyId != ''){
        filterCompanyId = `, "companyId": "${companyId}"`;
    }
    const url = apiUrl+`/accounts?filter={"where":{"active":true${filterPropertyId}${filterCompanyId}${filterKeyWord}${filterRole}},"include":[{"relation":"company"}] ${paging} }`;
    var resp = await callApi(url, options('GET'));

    return resp;
}

// const getAccountNotifys = async () => {//Account // page start at 0
//     let propertyId = myUtils.getUser().propertyId;
//     const url = apiUrl+`/accounts?filter={"where":{"active":true,"notify":true,"propertyId":"${propertyId}"},"fields": {"fcmToken": true}}`; //
//     var resp = await callApi(url, options('GET'));

//     return resp;
// }

// const getAccountNotifyByHomeId = async (homeId) => {//Account // page start at 0
//     let propertyId = myUtils.getUser().propertyId;
//     const url = apiUrl+`/accounts?filter={"where":{"active":true,"notify":true,"propertyId":"${propertyId}","homeId":"${homeId}"},"fields": {"fcmToken": true}}`; //
//     var resp = await callApi(url, options('GET'));

//     return resp;
// }

const getAccountAdmins = async ({ page = 0, pageSize = 100000, keyWord, propertyId, companyId}) => {//Account // page start at 0
    // let propertyId = myUtils.getUser().propertyId;
    let paging = `,"limit":${pageSize > 0 ? pageSize : 100},"offset":${page*pageSize},"order":"createdAt ASC"`; 

    let filterKeyWord = '';
    if(keyWord && keyWord != ''){
        filterKeyWord = `,"or":[{"code":{"like":"${keyWord}"}},{"username":{"like":"${keyWord}"}},{"email":{"like":"${keyWord}"}},{"firstName":{"like":"${keyWord}"}},{"lastName":{"like":"${keyWord}"}},{"phone":{"like":"${keyWord}"}}]`;
    }
    let filterPropertyId = '';
    if(propertyId && propertyId != ''){
        filterPropertyId = `,"propertyId":"${propertyId}"`;
    }
    let filterCompanyId= '';
    if(companyId && companyId != ''){
        filterCompanyId = `,"companyId":"${companyId}"`;
    }
    const url = apiUrl+`/accounts?filter={"where":{"active":true,"role":"Admin"${filterPropertyId}${filterCompanyId}${filterKeyWord}},"include":[{"relation":"company"}] ${paging} }`;
    var resp = await callApi(url, options('GET'));

    return resp;
}

const getAccountTechnicians = async ({ page = 0, pageSize = 100000, keyWord, technicianTypeId}) => {//Account // page start at 0
    let propertyId = myUtils.getUser().propertyId;
    let paging = `,"limit":${pageSize > 0 ? pageSize : 100},"offset":${page*pageSize},"order":"createdAt ASC"`; 

    let filterKeyWord = '';
    if(keyWord && keyWord != ''){
        filterKeyWord = `,"or":[{"code":{"like":"${keyWord}"}},{"username":{"like":"${keyWord}"}},{"email":{"like":"${keyWord}"}},{"firstName":{"like":"${keyWord}"}},{"lastName":{"like":"${keyWord}"}},{"phone":{"like":"${keyWord}"}}]`;
    }
    let filterTechnicianTypeId = '';
    if(technicianTypeId && technicianTypeId != ''){
        filterTechnicianTypeId = `, "technicianTypeIds": {"inq":["${technicianTypeId}"]}`;
    }
    const url = apiUrl+`/accounts?filter={"where":{"active":true,"role":"Technician","propertyId":"${propertyId}"${filterKeyWord}${filterTechnicianTypeId}},"include":[{"relation":"company"}] ${paging} }`;
    var resp = await callApi(url, options('GET'));

    return resp;
}

const getAccountPartners = async ({ page = 0, pageSize = 100000}) => {//Account // page start at 0
    let propertyId = myUtils.getUser().propertyId;
    let paging = `,"limit":${pageSize > 0 ? pageSize : 100},"offset":${page*pageSize},"order":"createdAt ASC"`; 

    const url = apiUrl+`/maintenance-partners?filter={"where":{"active":true} ${paging} }`;
    var resp = await callApi(url, options('GET'));

    return resp;
}

const getAccountDetail = async (accountId) => {
    const url = apiUrl+`/accounts/${accountId}?filter={"include":[{"relation":"company"}]}`;
    var resp = await callApi(url, options('GET'));

    return resp;
}

const getAccountsByEmail = async (email) => {
    let propertyId = myUtils.getUser().propertyId;
    const url = apiUrl+`/accounts?filter={"where":{"active":true,"propertyId":"${propertyId}","email":"${email}"},"include":[{"relation":"company"}]}`;
    var resp = await callApi(url, options('GET'));

    return resp;
}

const createAccount = async (body) => {
    const url = apiUrl+`/accounts`;
    const resp = callApi(url, options('POST', body));

    return resp;
}

const patchAccount = async (accountId, body) => {
    const url = apiUrl+`/accounts/${accountId}`;
    var resp = await callApi(url, options('PATCH', body));

    return resp;
}

const deleteAccount = async (accountId) => {
    const url = apiUrl+`/accounts/${accountId}`;
    var resp = await callApi(url, options('PATCH', {active:false}));
    const { status } = resp;
    if(status){
        await apiAuth.deleteUserAuth(accountId); // empty user collection
    }

    return resp;
}

const countAccount = async ({keyWord, role, propertyId, companyId}) => {
    let filterKeyWord = '';
    if(keyWord && keyWord != ''){
        filterKeyWord = `,"or":[{"code":{"like":"${keyWord}"}},{"username":{"like":"${keyWord}"}},{"email":{"like":"${keyWord}"}},{"firstName":{"like":"${keyWord}"}},{"lastName":{"like":"${keyWord}"}},{"phone":{"like":"${keyWord}"}}]`;
    }
    let filterRole = '';
    if(role && role != ''){
        filterRole = `, "role": "${role}"`;
    }
    let filterPropertyId = '';
    if(propertyId && propertyId != ''){
        filterPropertyId = `, "propertyId": "${propertyId}"`;
    }
    let filterCompanyId = '';
    if(companyId && companyId != ''){
        filterCompanyId = `, "companyId": "${companyId}"`;
    }
    const countUrl = `${apiUrl}/accounts/count?where={"active":true${filterKeyWord}${filterRole}${filterPropertyId}${filterCompanyId}}`;
    var resp = await callApi(countUrl, options('GET'));

    return resp;
}

export default {//Account API
    getAccounts,
    // getAccountNotifys,
    // getAccountNotifyByHomeId,
    getAccountAdmins,
    getAccountTechnicians,
    getAccountPartners,
    getAccountDetail,
    getAccountsByEmail,
    createAccount,
    patchAccount,
    deleteAccount,
    countAccount,

}